/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMenuSubCategoryModel as DigiworkMaitreDPosDtoMenuDeleteMenuSubCategoryModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/delete-menu-sub-category-model';

export interface DeleteSubCategory$Params {
      body?: DigiworkMaitreDPosDtoMenuDeleteMenuSubCategoryModel
}

export function deleteSubCategory(http: HttpClient, rootUrl: string, params?: DeleteSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSubCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSubCategory.PATH = '/api/gmn/Menu/deletesubcategory';
